module.exports = __webpack_public_path__ + "media/images/endicott_pear-193d10e09c7ba5a250973b7a660921bc.jpg";